import React from 'react';
import { Box, Card } from '@mui/material';

interface AuthPageLayoutProps {
    children: React.ReactNode;
    centered?: boolean;
    maxWidth?: number;
}

export const AuthPageLayout: React.FC<AuthPageLayoutProps> = ({
    children,
    centered = false,
    maxWidth = 500,
}) => {
    return (
        <Box
            sx={{
                backgroundImage:
                    'radial-gradient(circle at 50% 14em, #313264 0%, #00023b 60%, #00023b 100%)',
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
                alignItems: 'center',
                justifyContent: centered ? 'center' : 'flex-start',
                '& .MuiCard-root': {
                    minWidth: 300,
                    maxWidth,
                    marginTop: centered ? 0 : '4em',
                    background: '#ffffff',
                    margin: centered ? '16px' : '4em 16px 16px 16px',
                },
            }}
        >
            <Card>{children}</Card>
        </Box>
    );
};
